import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import ModalHelpMe from '../modal-help-me/modal-help-me'
import Icon from '../../atoms/icons/icon'
import { Button, BUTTON_COLOR } from '../../../components/atoms'
import { breakpoints, useMediaQuery } from '../../../lib/hooks'
import { cn } from '../../../shadcn/utils'

const HelpMeButton = ({
  dataGtm,
  style,
}: {
  dataGtm?: string
  style?: React.CSSProperties
}) => {
  const isMobile = useMediaQuery(breakpoints.newMobile)
  const [speakNowModal, setSpeakNowModal] = useState<boolean>(false)
  const [showHelpMe, setShowHelpMe] = useState<boolean>(false)
  const [buttonPressed, setButtonPressed] = useState<boolean>(false)

  return (
    <>
      <Button
        color={BUTTON_COLOR.SECONDARY}
        data-gtm={dataGtm}
        onClick={() => {
          if (!isMobile) {
            setShowHelpMe(true)
          }
          setSpeakNowModal(true)
          setButtonPressed(true)
        }}
        className={cn(s.helpMeBtn, 'focus-visible:ring-2')}
        contentClassName='flex gap-1 items-center [&>svg]:hidden [&>svg]:md:block'
        style={style}
        notification={true}
        buttonPressed={buttonPressed}
      >
        <Icon name='send' size={12} />
        <FormattedMessage
          id='ui.helpMe.sendBrief'
          defaultMessage='Envoyer mon brief'
        />
      </Button>
      <ModalHelpMe
        speakNowModal={speakNowModal}
        setSpeakNowModal={setSpeakNowModal}
        showHelpMe={showHelpMe}
        setShowHelpMe={setShowHelpMe}
      />
    </>
  )
}

export default HelpMeButton
